import type { Canvas as FabricCanvas } from 'fabric';
import { isEmpty } from '@witmetrics/utils/misc';

export const classes = {
  overlay: 'w-screen h-screen flex flex-col bg-white dark:bg-[#332e43]',
  viewerWrapper: 'w-full grow flex flex-col',
  hidden: 'pointer-events-none',
  canvasWrapper: 'w-full grow relative bg-grey-8',
  canvas: 'absolute top-0 left-0 size-full',
  loadingWrapper: 'absolute top-0 left-0 size-full place-center z-10',
  loadingCard:
    'py-6 px-12 shadow-dialog text-xl text-grey-8 dark:text-mauve-1 font-light',
};

export function getMouthBoundingBox(fabric: FabricCanvas) {
  let minX: number | null = null;
  let minY: number | null = null;
  let maxX: number | null = null;
  let maxY: number | null = null;
  const objects = fabric
    .getObjects()
    .filter((obj) => !['BEFORE', 'FACE'].includes(obj.imageType!));
  if (isEmpty(objects)) {
    return { width: 0, height: 0, left: 0, top: 0, objects };
  }
  objects.forEach((mask) => {
    const { width, height, left, top } = mask.getBoundingRect();
    if (!minX || left < minX) minX = left;
    if (!maxX || left + width > maxX) maxX = left + width;
    if (!minY || top < minY) minY = top;
    if (!maxY || top + height > maxY) maxY = top + height;
  });

  return {
    width: maxX! - minX!,
    height: maxY! - minY!,
    left: minX!,
    top: minY!,
    objects,
  };
}
